import { captureError } from './capture.utilities';

export class CustomError extends Error {
	customData?: any;

	constructor(message: string, customData?: any) {
		super(message);
		this.customData = customData;
		Object.setPrototypeOf(this, CustomError.prototype);
	}
}

export function throwCustomError(error: any, data?: Record<string, unknown>[]) {
	if (!(error instanceof Error)) {
		captureError('app:throwCustomError', error, {
			tags: { operation: 'app:throwCustomError' },
		});
		throw new CustomError('Unknown error type', {
			originalError: error,
			...(data ? { additionalData: data } : {}),
		});
	} else if (!(error instanceof CustomError)) {
		const stackArray = error.stack ? error.stack.split('\n') : [];
		const customError = new CustomError(error.message, {
			originalError: { ...error, stack: stackArray },
			...(data ? { additionalData: data } : {}),
		});
		throw customError;
	} else {
		if (data) {
			error.customData = { ...error.customData, additionalData: data };
		}
		throw error;
	}
}
